import http from '../../../Services/api.laravel.http';

export const TermConditionService = {
 	getSingleTermCondition: (id) => http.get('/admin/term-condition/' + id),
	paginateWithSearchTermCondition: (formParams) => http.post('/admin/term-condition/search', formParams),
 	TermConditionPost: (formParams) => http.post('/admin/term-condition', formParams),
 	updateSingleTermCondition: (formParams, id) => http.put('/admin/term-condition/' + id, formParams),
	ArchiveTermCondition: (formParams) => http.post('/admin/term-condition/archives/list', formParams),
}
